import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-611433eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "statusCard shadowed" }
const _hoisted_2 = { class: "headerRow" }
const _hoisted_3 = { class: "nameAndCreated" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "created pt-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "createdLabel" }, "Started: ", -1))
const _hoisted_7 = { class: "createdDate" }
const _hoisted_8 = {
  key: 0,
  class: "statusMessage mt-2 is-flex is-flex-direction-row"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle mt-1 mr-2" }, null, -1))
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "status" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "statusLabel" }, "Current Status:", -1))
const _hoisted_13 = {
  key: 0,
  class: "documentSection"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "statusLabel pb-2" }, "Your documents are available to download:", -1))
const _hoisted_15 = {
  key: 2,
  class: "statusHistory"
}
const _hoisted_16 = { style: {"text-align":"left"} }
const _hoisted_17 = {
  key: 0,
  class: "historyPipe historyPipeDown"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "historyPipe historyPipeBoth"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot" }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 2,
  class: "historyPipe historyPipeUp"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot" }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "historyLabel" }
const _hoisted_27 = {
  key: 0,
  class: "historyPipe historyPipeBoth"
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "historyDescription" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "historyPipe historyPipeBoth" }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]

import { formatDateAs, notifyNetworkError } from '@/core/utils';
import { ApplicationStatus, Core } from "@minicity/core";
import { computed, ref } from 'vue';
import OnlineSocialSecurityApplicationStatus from '@/features/applications/onlineSocialSecurity/OnlineSocialSecurityApplicationStatus.vue';
import MarkdownIt from "markdown-it";
import { sessionState } from '@/core/session';
import DocumentUploadWidget from '@/components/DocumentUploadWidget.vue';
import { getAttachmentViewLink } from './api';


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationStatusCard',
  props: {
    application: null
  },
  emits: ['changed'],
  setup(__props: any, { emit }) {

const props = __props as {
  application: ApplicationStatus.Report,
}





const currentStatus = computed(() => {
  let status = null;
  for (let entry of props.application.history) {
    if (entry.type != "FUTURE") { status = entry; }
  }
  return status;
});

const opened = ref<boolean>(false);

const keyDocument = computed(() => {
  switch (props.application.applicationType) {
    case Core.EntityType['Birth Record']:
      return sessionState.session?.user.keyDocuments["BIRTH_RECORD"];
    case Core.EntityType['Georgia DFCS Benefits']:
      return sessionState.session?.user.keyDocuments["GEORGIA_DFCS_BENEFITS"];
    case Core.EntityType['Social Security']:
    case Core.EntityType['Online Social Security']:
      return sessionState.session?.user.keyDocuments["SOCIAL_SECURITY"];
    default:
      return undefined;
  }
});

const downloadDocument = (doc: Core.Document) => {
  getAttachmentViewLink(doc)
    .then((attachmentViewLink: string) => window.open(attachmentViewLink))
    .catch(err => notifyNetworkError("Failed to download attachment", err));
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(__props.application.name), 1),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(formatDateAs)(__props.application.submittedAt, "MM/DD/YYYY")), 1)
        ]),
        (__props.application.statusMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", {
                innerHTML: new _unref(MarkdownIt)().render(__props.application.statusMessage)
              }, null, 8, _hoisted_10)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", {
          style: {"width":"fit-content"},
          class: _normalizeClass(["statusName my-1", _unref(currentStatus)!.type])
        }, _toDisplayString(_unref(currentStatus)!.label), 3)
      ])
    ]),
    (_unref(keyDocument)?.attachments.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(DocumentUploadWidget, {
            documents: _unref(keyDocument)?.attachments,
            onView: _cache[0] || (_cache[0] = ($event: any) => (downloadDocument($event))),
            readonly: ""
          }, null, 8, ["documents"])
        ]))
      : _createCommentVNode("", true),
    (__props.application.applicationType == _unref(Core).EntityType['Online Social Security'])
      ? (_openBlock(), _createBlock(OnlineSocialSecurityApplicationStatus, {
          key: 1,
          application: __props.application,
          onChanged: _cache[1] || (_cache[1] = ($event: any) => (emit('changed')))
        }, null, 8, ["application"]))
      : _createCommentVNode("", true),
    (opened.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("table", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.application.history, (item, idx) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                _createElementVNode("tr", {
                  class: _normalizeClass(item.type)
                }, [
                  (idx == 0)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_17, _hoisted_19))
                    : (idx < __props.application.history.length-1)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_20, _hoisted_22))
                      : (_openBlock(), _createElementBlock("td", _hoisted_23, _hoisted_25)),
                  _createElementVNode("td", _hoisted_26, _toDisplayString(item.label), 1)
                ], 2),
                _createElementVNode("tr", null, [
                  (idx != __props.application.history.length-1)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_27))
                    : (_openBlock(), _createElementBlock("td", _hoisted_28)),
                  _createElementVNode("td", _hoisted_29, _toDisplayString(item.date ? `${_unref(formatDateAs)(item.date, 'MM/DD/YYYY')}: ` : '') + _toDisplayString(item.description), 1)
                ]),
                (idx != __props.application.history.length-1)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_30, _hoisted_33))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (opened.value)
      ? (_openBlock(), _createElementBlock("i", {
          key: 3,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (opened.value=false)),
          class: "toggleButton fas fa-chevron-up"
        }))
      : (_openBlock(), _createElementBlock("i", {
          key: 4,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (opened.value=true)),
          class: "toggleButton fas fa-chevron-down"
        }))
  ]))
}
}

})